import clsx from 'clsx';
import {
  BoxContainer,
  type IBoxContainerProps,
} from 'components/UI/Layout/Containers/BoxContainer';
import { type ITextLink, TextLink } from 'components/UI/Link/TextLink';

import styles from './IndustryComparisonConditionalLink.module.scss';

const newWindowLinkProps = { target: '_blank', rel: 'noopener noreferrer' };

const IndustryRenderLink = ({ children, ...linkProps }: ITextLink) => {
  return (
    <TextLink {...linkProps} underline="none">
      {children}
    </TextLink>
  );
};

interface IIndustryComparisonConditionalLinkProps extends IBoxContainerProps {
  href?: ITextLink['href'];
  isActive?: boolean;
  type?: string | null;
}

export const IndustryComparisonConditionalLink = ({
  children,
  className,
  isActive,
  href,
  type,
  ...restProps
}: IIndustryComparisonConditionalLinkProps) => {
  const hrefAttrs = {
    // if there is an `href` attr, add it and get the clickable
    // `IndustryRenderLink` instead of the `div` element
    ...(href && { href }),
    // on3 links redirect inline with the `NextLink` component
    // all other services pop up in new window
    ...(type?.toLowerCase() !== 'on3' && { ...newWindowLinkProps }),
  };

  return (
    <BoxContainer
      className={clsx(
        className,
        styles.conditionalLink,
        isActive && styles.active,
      )}
      component={href ? IndustryRenderLink : 'div'}
      {...restProps}
      {...hrefAttrs}
    >
      <>{children}</>
    </BoxContainer>
  );
};
